// api types
export const ACCOUNTS_API_TYPE = 'accounts';
export const SWAPS_API_TYPE = 'transactions';
export const TRANSACTIONS_API_TYPE = 'transactions';
export const BLOCKS_API_TYPE = 'blocks';
export const KPI_API_TYPE = 'metrics';

// networks
export const CHRONOS_NETWORK = 'chronos';
